import "./styles.css";

export function ButtonConnect() {
  return (
    <button className="btn-connect">
      Vamos nos conectar
    </button>
  );
}
